import apiClient from '../lib/apiClient';

const userManagementService = {
  // Get all users
  getUsers: async (filters = {}) => {
    try {
      const result = await apiClient.get('/user-management', filters);
      return result;
    } catch (error) {
      return { success: false, error: error.message || 'Failed to fetch users' };
    }
  },

  // Get single user by ID
  getUser: async (id) => {
    try {
      const result = await apiClient.get(`/user-management/${id}`);
      return result;
    } catch (error) {
      return { success: false, error: error.message || 'Failed to fetch user' };
    }
  },

  // Create new user
  createUser: async (userData) => {
    try {
      const result = await apiClient.post('/user-management', userData);
      return result;
    } catch (error) {
      return { success: false, error: error.message || 'Failed to create user' };
    }
  },

  // Update user
  updateUser: async (id, userData) => {
    try {
      const result = await apiClient.put(`/user-management/${id}`, userData);
      return result;
    } catch (error) {
      return { success: false, error: error.message || 'Failed to update user' };
    }
  },

  // Delete user
  deleteUser: async (id) => {
    try {
      const result = await apiClient.delete(`/user-management/${id}`);
      return result;
    } catch (error) {
      return { success: false, error: error.message || 'Failed to delete user' };
    }
  },

  // Get available modules
  getModules: async () => {
    try {
      const result = await apiClient.get('/user-management/modules');
      return result;
    } catch (error) {
      return { success: false, error: error.message || 'Failed to fetch modules' };
    }
  }
};

export default userManagementService;

